export default function isMimeType(constraintType: MimeTypeStruct|undefined, expectedMainType: string, expectedSubType: string) {
    return expectedMainType === constraintType?.mainType && expectedSubType === constraintType?.subType;
}
